export const index = '/';
export const forgotPassword = '/forgot-password';
export const invitation = '/invitation';
export const login = '/login';
export const signUp = '/sign-up';
export const logout = '/logout';

export const group = '/group/:group_id';
export const groupCreate = '/group/create';
export const groupEdit = '/group/:group_id/edit';
export const groupMembers = '/group/:group_id/members';
export const groupApproval = '/group/:group_id/approval';
export const groupRemoved = '/group/:group_id/removed';
export const groups = '/groups';
export const groupsDepartment = '/groups/department/:department_id';
export const groupsLocation = '/groups/location/:location_id';
export const groupsOwned = '/groups/owned';
export const groupsFollowing = '/groups/following';
export const groupsAll = '/groups/all';

export const people = '/people';
export const peopleFollowing = '/people/following';
export const peopleEveryone = '/people/everyone';
export const peopleDepartment = '/people/department/:department_id';
export const peopleLocation = '/people/location/:location_id';
export const profile = '/profile/:profile_id';
export const profileGroups = '/profile/:profile_id/groups';
export const profileFollowing = '/profile/:profile_id/following';
export const profileFollowers = '/profile/:profile_id/followers';

export const activity = '/activity';

export const leaderboard = '/leaderboard';
export const leaderboardView = '/leaderboard/:leaderboard_id';

export const admin = '/admin';
export const adminPosts = '/admin/posts';
export const adminPeople = '/admin/people';
export const adminPeopleInvite = '/admin/people/invite';
export const adminGroups = '/admin/groups';
export const adminInvitations = '/admin/invitations';
export const adminMessages = '/admin/messages';
export const adminLeaderboards = '/admin/leaderboards';
export const adminReports = '/admin/reports';

export const adminSettingsAccount = '/admin/settings/account';
export const adminSettingsCompanyOnboarding = '/admin/settings/company-onboarding';
export const adminSettingsCustomOnboarding = '/admin/settings/custom-onboarding';
export const adminSettingsUserSegments = '/admin/settings/user-segments';
export const adminSettingsShareTracking = '/admin/settings/share-tracking';

export const account = '/account';
export const connectionSuccess = '/connections/success';
export const connectionFailure = '/connections/failure';
export const content = '/content/:content_id';
export const onboarding = '/onboarding';
export const onboardingProfile = '/onboarding/profile';
export const onboardingFollows = '/onboarding/follows';
export const notifications = '/notifications';
export const search = '/search';

export const clientSuccess = '/client-success';

export const PUBLIC_ROUTES = [forgotPassword, invitation, login, signUp];

export const HOME_TAB_ROUTES = [index];

export const GROUPS_TAB_ROUTES = [
  group,
  groupCreate,
  groupEdit,
  groupsDepartment,
  groupsLocation,
  groupMembers,
  groupApproval,
  groupRemoved,
  groups,
  groupsOwned,
  groupsFollowing,
  groupsAll,
];

export const PEOPLE_TAB_ROUTES = [
  people,
  peopleFollowing,
  peopleEveryone,
  peopleDepartment,
  peopleLocation,
  profile,
  profileGroups,
  profileFollowing,
  profileFollowers,
];

export const ACTIVITY_TAB_ROUTES = [activity];

export const LEADERBOARD_TAB_ROUTES = [leaderboard, leaderboardView];

export const ADMIN_TAB_ROUTES = [
  admin,
  adminPeople,
  adminPeopleInvite,
  adminGroups,
  adminInvitations,
  adminMessages,
  adminLeaderboards,
  adminReports,
  adminSettingsAccount,
  adminSettingsCompanyOnboarding,
  adminSettingsCustomOnboarding,
  adminSettingsUserSegments,
  adminSettingsShareTracking,
];

export const PROTECTED_ROUTES = [
  account,
  content,
  notifications,
  onboardingProfile,
  onboardingFollows,
  search,
  ...GROUPS_TAB_ROUTES,
  ...PEOPLE_TAB_ROUTES,
  ...ACTIVITY_TAB_ROUTES,
  ...ADMIN_TAB_ROUTES,
];
